import { __assign } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import { Arrow, Calendar, Container, DayTile, DaysDiv, HourMinuteItem, HoursDiv, HoursMinutesColumn, InputContainer, MonthHeader, SelectDiv, WeekdayTile, } from "./styles";
import { addDays, addMonths, compareAsc, differenceInDays, eachDayOfInterval, endOfDay, endOfMonth, endOfWeek, endOfYear, format, set, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays, subMonths, subWeeks, } from "date-fns";
import { TiArrowSortedDown } from "react-icons/ti";
import { weekdays, months, minutes, hours } from "../../../utils/constants";
import { fillDaysArray, formatDateToString, hexToRgb, } from "../../../utils/functions";
import { FaCalendar } from "react-icons/fa";
import { Spinner } from "../../Spinner/styles";
export var FullHourCalendar = function (_a) {
    var value = _a.value, onDateSelected = _a.onDateSelected, calendarColor = _a.calendarColor, isEnd = _a.isEnd, onError = _a.onError, hideFields = _a.hideFields, isLoading = _a.isLoading, disabled = _a.disabled, maxRange = _a.maxRange;
    var now = new Date();
    var calendarRef = useRef();
    var customColor = hexToRgb(calendarColor || "#ff2c3a");
    var _b = useState(0), leftDistance = _b[0], setLeftDistance = _b[1];
    var _c = useState(false), showCalendar = _c[0], setShowCalendar = _c[1];
    var _d = useState(value), daySelected = _d[0], setDaySelected = _d[1];
    var _e = useState({
        start: startOfMonth(now),
        end: endOfMonth(now)
    }), monthToShow = _e[0], setMonthToShow = _e[1];
    var _f = useState([]), daysToShow = _f[0], setDaysToShow = _f[1];
    var checkHide = function (field) {
        return !(hideFields === null || hideFields === void 0 ? void 0 : hideFields.includes(field));
    };
    useEffect(function () {
        var daysOfTheMonth = eachDayOfInterval(monthToShow);
        fillDaysArray(daysOfTheMonth);
        setDaysToShow(daysOfTheMonth.map(function (day) {
            return {
                value: day,
                day: day.getDate(),
                month: day.getMonth(),
                year: day.getFullYear(),
                weekday: day.getDay()
            };
        }));
    }, [monthToShow]);
    useEffect(function () {
        setDaySelected(value);
    }, [value]);
    useEffect(function () {
        if (calendarRef.current) {
            setLeftDistance(calendarRef.current.getBoundingClientRect().left);
        }
    }, [calendarRef]);
    useEffect(function () {
        if (compareAsc(daySelected.start, daySelected.end) > 0) {
            setDaySelected(function (state) {
                return __assign(__assign({}, state), { end: endOfDay(state.start) });
            });
            if (onError) {
                onError("Data final não pode ser menor do que data inicial");
            }
        }
        if (maxRange &&
            differenceInDays(daySelected.end, daySelected.start) > maxRange) {
            setDaySelected(function (state) {
                return __assign(__assign({}, state), { end: endOfDay(addDays(state.start, maxRange)) });
            });
            if (onError) {
                onError("Diferen\u00E7a m\u00E1xima deve ser de ".concat(maxRange, " dias"));
            }
        }
    }, [daySelected]);
    return (React.createElement(Container, { ref: calendarRef },
        React.createElement("div", { style: {
                position: "absolute",
                top: 36,
                right: -4,
                overflow: "hidden",
                width: 45,
                height: 25,
                zIndex: 10000
            } },
            React.createElement(Arrow, { show: showCalendar })),
        React.createElement(InputContainer, { customColor: customColor, disabled: disabled, onClick: function () {
                setShowCalendar(!showCalendar);
            } },
            React.createElement("span", null, daySelected
                ? formatDateToString(isEnd ? daySelected.end : daySelected.start) +
                    " - " +
                    format(isEnd ? daySelected.end : daySelected.start, "HH:mm")
                : ""),
            isLoading ? (React.createElement(Spinner, { background: "#666", inverted: true, size: 10 })) : (React.createElement(FaCalendar, { color: disabled ? "#666" : customColor.normal, size: 16 }))),
        React.createElement(Calendar, { id: "calendar", show: showCalendar, leftDistance: leftDistance },
            React.createElement("div", { style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: "100%",
                    width: "100%",
                    backgroundColor: "transparent",
                    zIndex: 0
                }, onClick: function () {
                    if (onDateSelected) {
                        console.log("onDateSelected", daySelected);
                        onDateSelected(daySelected);
                    }
                    setShowCalendar(false);
                } }),
            React.createElement(SelectDiv, null,
                checkHide("today") && (React.createElement("span", { onClick: function () {
                        onDateSelected &&
                            onDateSelected({
                                start: startOfDay(now),
                                end: endOfDay(now)
                            });
                        setShowCalendar(false);
                    } }, "Hoje")),
                checkHide("yesterday") && (React.createElement("span", { onClick: function () {
                        onDateSelected &&
                            onDateSelected({
                                start: startOfDay(subDays(now, 1)),
                                end: endOfDay(subDays(now, 1))
                            });
                        setShowCalendar(false);
                    } }, "Ontem")),
                checkHide("this_week") && (React.createElement("span", { onClick: function () {
                        onDateSelected &&
                            onDateSelected({
                                start: startOfWeek(now),
                                end: endOfWeek(now)
                            });
                        setShowCalendar(false);
                    } }, "Essa semana")),
                checkHide("last_week") && (React.createElement("span", { onClick: function () {
                        onDateSelected &&
                            onDateSelected({
                                start: startOfWeek(subWeeks(now, 1)),
                                end: endOfWeek(subWeeks(now, 1))
                            });
                        setShowCalendar(false);
                    } }, "Semana anterior")),
                checkHide("this_month") && (React.createElement("span", { onClick: function () {
                        onDateSelected &&
                            onDateSelected({
                                start: startOfMonth(now),
                                end: endOfMonth(now)
                            });
                        setShowCalendar(false);
                    } }, "Esse m\u00EAs")),
                checkHide("last_month") && (React.createElement("span", { onClick: function () {
                        onDateSelected &&
                            onDateSelected({
                                start: startOfMonth(subMonths(now, 1)),
                                end: endOfMonth(subMonths(now, 1))
                            });
                        setShowCalendar(false);
                    } }, "M\u00EAs anterior")),
                checkHide("this_year") && (React.createElement("span", { onClick: function () {
                        onDateSelected &&
                            onDateSelected({
                                start: startOfYear(now),
                                end: endOfYear(now)
                            });
                        setShowCalendar(false);
                    } }, "Esse ano"))),
            React.createElement("div", { style: { zIndex: 2 } },
                React.createElement(MonthHeader, { customColor: customColor },
                    React.createElement("div", null),
                    React.createElement("span", null, monthToShow.start.getFullYear()),
                    React.createElement("div", null)),
                React.createElement(MonthHeader, { customColor: customColor, style: { borderRadius: 0 } },
                    React.createElement(TiArrowSortedDown, { onClick: function () {
                            return setMonthToShow({
                                start: subMonths(monthToShow.start, 1),
                                end: subMonths(monthToShow.end, 1)
                            });
                        }, color: customColor.normal, size: 25, style: {
                            transform: "rotate(90deg)"
                        } }),
                    React.createElement("span", null, months[monthToShow.start.getMonth()]),
                    React.createElement(TiArrowSortedDown, { onClick: function () {
                            return setMonthToShow({
                                start: addMonths(monthToShow.start, 1),
                                end: addMonths(monthToShow.end, 1)
                            });
                        }, color: customColor.normal, size: 25, style: {
                            transform: "rotate(-90deg)"
                        } })),
                React.createElement(DaysDiv, null,
                    weekdays.map(function (wd, i) { return (React.createElement(WeekdayTile, { idx: i }, wd)); }),
                    daysToShow.map(function (day, i) {
                        return (React.createElement(DayTile, { key: i, day: day, customColor: customColor, clicked: format(isEnd ? daySelected.end : daySelected.start, "dd/MM/yy") === format(day.value, "dd/MM/yy"), isThisMonth: day.month !== monthToShow.start.getMonth(), onClick: function () {
                                var dayValue = isEnd ? endOfDay(day.value) : day.value;
                                setDaySelected(function (state) {
                                    return isEnd
                                        ? __assign(__assign({}, state), { end: dayValue }) : __assign(__assign({}, state), { start: dayValue });
                                });
                            } }, day.day));
                    }))),
            React.createElement(HoursDiv, null,
                React.createElement(HoursMinutesColumn, null, hours.map(function (h) {
                    var _a, _b;
                    var hoursSelected = isEnd
                        ? (_a = daySelected.end) === null || _a === void 0 ? void 0 : _a.getHours()
                        : (_b = daySelected.start) === null || _b === void 0 ? void 0 : _b.getHours();
                    return (React.createElement(HourMinuteItem, { customColor: customColor, isSelected: hoursSelected === h, onClick: function () {
                            setDaySelected(function (state) {
                                return isEnd
                                    ? __assign(__assign({}, state), { end: set(state.end, { hours: h }) }) : __assign(__assign({}, state), { start: set(state.start, { hours: h }) });
                            });
                        } }, h.toString().padStart(2, "0")));
                })),
                React.createElement("div", null, ":"),
                React.createElement(HoursMinutesColumn, null, minutes.map(function (m) {
                    var _a, _b;
                    var minutesSelected = isEnd
                        ? (_a = daySelected.end) === null || _a === void 0 ? void 0 : _a.getMinutes()
                        : (_b = daySelected.start) === null || _b === void 0 ? void 0 : _b.getMinutes();
                    return (React.createElement(HourMinuteItem, { customColor: customColor, isSelected: minutesSelected === m, onClick: function () {
                            setDaySelected(function (state) {
                                return isEnd
                                    ? __assign(__assign({}, state), { end: set(state.end, { minutes: m }) }) : __assign(__assign({}, state), { start: set(state.start, { minutes: m }) });
                            });
                        } }, m.toString().padStart(2, "0")));
                }))))));
};
//# sourceMappingURL=index.js.map